 import { IExportColumnModel } from '../../../../../shared/models/export.column.model'
 export const CustomerFaviconColumnList: IExportColumnModel[] = [
]